<template>
    <div class="Match">

        <div class="Match__body">

            <div class="Match__line">

                <div class="Match__player__holder" v-if="fakeData">

                    <div class="Match__player" v-if="getWinner(0)">

                        <img class="small-flag" :src="flagPath + getWinner(0)[2].toLowerCase() + '.svg'"
                             :alt="getWinner(0)[2]">

                        <span class="Match__player__fn generic-medium">{{getWinner(0)[0]}}</span><span class="Match__player__i generic-medium">{{initial(getWinner(0)[0])}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{getWinner(0)[1]}}</span>
                        <span class="Match__player__seed"
                              v-if="getWinner(0)[3]">[{{getWinner(0)[3]}}]</span>

                    </div>

                    <div class="Match__player" v-if="getWinner(0) && getWinner(0)[4] == 1">

                        <img class="small-flag" :src="flagPath + getWinner(0)[7].toLowerCase() + '.svg'"
                             :alt="getWinner(0)[8]">

                        <span class="Match__player__fn generic-medium">{{getWinner(0)[5]}}</span><span class="Match__player__i generic-medium">{{initial(getWinner(0)[5])}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{getWinner(0)[6]}}</span>
                        <span class="Match__player__seed"
                              v-if="getWinner(0)[3]">[{{getWinner(0)[3]}}]</span>

                    </div>

                    <div class="Match__player" v-if="getBye(0)">

                        <img class="small-flag" :src="flagPath + getBye(0)[2].toLowerCase() + '.svg'"
                             :alt="getBye(0)[2]">

                        <span class="Match__player__fn generic-medium">{{getBye(0)[0]}}</span><span class="Match__player__i generic-medium">{{initial(getBye(0)[0])}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{getBye(0)[1]}}</span>
                        <span class="Match__player__seed"
                              v-if="getBye(0)[3]">[{{getBye(0)[3]}}]</span>

                    </div>

                    <div class="Match__player" v-if="getBye(0) && getBye(0)[4] == 1">

                        <img class="small-flag" :src="flagPath + getBye(0)[7].toLowerCase() + '.svg'"
                             :alt="getBye(0)[8]">

                        <span class="Match__player__fn generic-medium">{{getBye(0)[5]}}</span><span class="Match__player__i generic-medium">{{initial(getBye(0)[5])}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{getBye(0)[6]}}</span>
                        <span class="Match__player__seed"
                              v-if="getBye(0)[3]">[{{getBye(0)[3]}}]</span>

                    </div>


                </div>

            </div>

            <div class="Match__line">

                <div class="Match__player__holder" v-if="fakeData">

                    <div class="Match__player" v-if="getWinner(1)">

                        <img class="small-flag" :src="flagPath + getWinner(1)[2].toLowerCase() + '.svg'"
                             :alt="getWinner(1)[2]">

                        <span class="Match__player__fn generic-medium">{{getWinner(1)[0]}}</span><span class="Match__player__i generic-medium">{{initial(getWinner(1)[0])}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{getWinner(1)[1]}}</span>
                        <span class="Match__player__seed"
                              v-if="getWinner(1)[3]">[{{getWinner(1)[3]}}]</span>

                    </div>

                    <div class="Match__player" v-if="getWinner(1) && getWinner(1)[4] == 1">

                        <img class="small-flag" :src="flagPath + getWinner(1)[7].toLowerCase() + '.svg'"
                             :alt="getWinner(1)[8]">

                        <span class="Match__player__fn generic-medium">{{getWinner(1)[5]}}</span><span class="Match__player__i generic-medium">{{initial(getWinner(1)[5])}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{getWinner(1)[6]}}</span>
                        <span class="Match__player__seed"
                              v-if="getWinner(1)[3]">[{{getWinner(1)[3]}}]</span>

                    </div>

                    <div class="Match__player" v-if="getBye(1)">

                        <img class="small-flag" :src="flagPath + getBye(1)[2].toLowerCase() + '.svg'"
                             :alt="getBye(1)[2]">

                        <span class="Match__player__fn generic-medium">{{getBye(1)[0]}}</span><span class="Match__player__i generic-medium">{{initial(getBye(1)[0])}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{getBye(1)[1]}}</span>
                        <span class="Match__player__seed"
                              v-if="getBye(1)[3]">[{{getBye(1)[3]}}]</span>

                    </div>

                    <div class="Match__player" v-if="getBye(1) && getBye(1)[4] == 1">

                        <img class="small-flag" :src="flagPath + getBye(1)[7].toLowerCase() + '.svg'"
                             :alt="getBye(1)[8]">

                        <span class="Match__player__fn generic-medium">{{getBye(1)[5]}}</span><span class="Match__player__i generic-medium">{{initial(getBye(1)[5])}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{getBye(1)[6]}}</span>
                        <span class="Match__player__seed"
                              v-if="getBye(1)[3]">[{{getBye(1)[3]}}]</span>

                    </div>

                </div>

            </div>

        </div>

        <div class="Match__meta" v-if="fakeData">

            <div class="Match__time">
                <span v-html="ico_clock"></span>
                --:--
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        props: ['selectedRound', 'rounds', 'round', 'pos', 'roundPos', 'flagPath', 'lines', 'drawline'],
        data() {
            return {
                relatedMatches: [],
                fakeData: false,
                roundIndex: '',
                ico_pointer_right: window.ico_pointer_right,
                ico_winner: window.ico_tick,
                ico_clock: window.ico_clock
            }
        },
        mounted: function () {

            let relatedMatches = this.getRelatedMatches()

            this.relatedMatches = relatedMatches
            this.fakeData = this.anyFinished(relatedMatches)

        },
        methods: {
            getRelatedMatches() {
                let currentRound = this.rounds.findIndex(round => round.id == this.round)
                this.roundIndex = currentRound
                let firstRelatedMatch = this.rounds[currentRound - 1].matches[this.pos * 2]
                let secondRelatedMatch = this.rounds[currentRound - 1].matches[(this.pos * 2) + 1]

                return [
                    firstRelatedMatch,
                    secondRelatedMatch
                ]

            },
            anyFinished(matches) {
                let anyFinished = false

                if (matches.length == 0) {
                    return false
                }

                for (let match of matches) {
                    if (match.detail != '' && match.detail.state == 'F') {
                        anyFinished = true
                    }
                }

                if (this.checkBye() == true) {
                    anyFinished = true
                }

                return anyFinished
            },
            checkBye() {
                let state = false
                let relatedPos = this.pos * 2

                if ( this.drawline == true && this.roundPos == 0 ) {
                    return false
                }

                if ( this.drawline == false && this.roundIndex != 1 ) {
                    return false
                }

                if (this.lines[relatedPos].nAF == 'Bye' || this.lines[relatedPos].nBF == 'Bye') {
                    state = true
                }

                if (this.lines[relatedPos + 1].nAF == 'Bye' || this.lines[relatedPos + 1].nBF == 'Bye') {
                    state = true
                }

                return state
            },
            initial(name) {
                return `${name.charAt(0)}.`
            },
            maybeBye() {
                if (this.drawline == false) {
                    return false
                }
            },
            getBye(which) {
                let relatedPos = this.pos * 2 + which

                if ( this.drawline == true && this.roundPos == 0 ) {
                    return false
                }

                if ( this.drawline == false && this.roundIndex != 1 ) {
                    return false
                }

                if (this.lines[relatedPos].nAF == 'Bye') {

                    let doubles = 0

                    if ( this.lines[relatedPos].nB2F != '' ) {
                        doubles = 1
                    }

                    return [
                        this.lines[relatedPos].nBF,
                        this.lines[relatedPos].nBL,
                        this.lines[relatedPos].cB,
                        this.lines[relatedPos].seedB,
                        doubles,
                        this.lines[relatedPos].nB2F,
                        this.lines[relatedPos].nB2L,
                        this.lines[relatedPos].cB2,
                    ]
                }

                if (this.lines[relatedPos].nBF == 'Bye') {

                    let doubles = 0

                    if ( this.lines[relatedPos].nA2F != '' ) {
                        doubles = 1
                    }

                    return [
                        this.lines[relatedPos].nAF,
                        this.lines[relatedPos].nAL,
                        this.lines[relatedPos].cA,
                        this.lines[relatedPos].seedA,
                        doubles,
                        this.lines[relatedPos].nA2F,
                        this.lines[relatedPos].nA2L,
                        this.lines[relatedPos].cA2,
                    ]
                }

                return false
            },
            getWinner(which) {
                if (this.relatedMatches[which].detail == '') {
                    return false
                }

                if (this.relatedMatches[which].detail.state != 'F') {
                    return false
                }

                if (this.relatedMatches[which].detail.winner == '2' || this.relatedMatches[which].detail.winner == '4' || this.relatedMatches[which].detail.winner == '6') {
                    return [
                        this.relatedMatches[which].detail.nAF,
                        this.relatedMatches[which].detail.nAL,
                        this.relatedMatches[which].detail.cA,
                        this.relatedMatches[which].detail.seedA,
                        this.relatedMatches[which].detail.isDoubles,
                        this.relatedMatches[which].detail.nA2F,
                        this.relatedMatches[which].detail.nA2L,
                        this.relatedMatches[which].detail.cA2,
                    ]
                }

                if (this.relatedMatches[which].detail.winner == '3' || this.relatedMatches[which].detail.winner == '5' || this.relatedMatches[which].detail.winner == '7') {
                    return [
                        this.relatedMatches[which].detail.nBF,
                        this.relatedMatches[which].detail.nBL,
                        this.relatedMatches[which].detail.cB,
                        this.relatedMatches[which].detail.seedB,
                        this.relatedMatches[which].detail.isDoubles,
                        this.relatedMatches[which].detail.nB2F,
                        this.relatedMatches[which].detail.nB2L,
                        this.relatedMatches[which].detail.cB2,
                    ]
                }

            }
        }
    }
</script>
